// extracted by mini-css-extract-plugin
export default {"previewContainer":"O25M7_EO9aFVhWTLLxwd","indicatorsContainer":"OGpqWMNMdbkzUPP6vCM6","buttonsContainer":"d6BtZux4S9ez1rY7ZuOA","tip":"KZgkEEPhXVjT7ejJsGzV"};